import React from 'react';
import { Link } from 'react-router-dom';

const BottomBar = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="bg-white py-4 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
        <p className="text-gray-600 text-sm">
          &copy; {currentYear} VA Sprouts. All rights reserved.
        </p>
        <div className="flex space-x-6 mt-4 md:mt-0">
          <Link to="/community-guidelines" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
            Guidelines
          </Link>
          <Link to="/privacy-policy" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
            Privacy
          </Link>
          <Link to="/terms-of-service" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
            Terms
          </Link>
          <Link to="/cookies-policy" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
            Cookies
          </Link>
          <Link to="/sitemap" className="text-gray-600 hover:text-gray-900 text-sm transition-colors">
            Sitemap
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
